// extracted by mini-css-extract-plugin
export default {"autoSuggest":"autoSuggest---n01lR","textFieldDiv":"textFieldDiv---n7H_K","downshift":"downshift---JlXbV"};